"use client";
import { Navbar, Footer } from "@/components";
import RebottManualSection from "@/components/rebott-manual-section";  

export default function RebottManualPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-[40vh]">
        <RebottManualSection />
      </main>
      <Footer />
    </>
  );
}
